import styled, { css } from 'styled-components';

export const Main = styled.div`
  display: block;
  position: relative;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #1F266B;
  animation: PreloaderSpin 1.5s linear infinite;

  ${props => props.width && css`
    width: ${props.width}px;
    min-width: ${props.width}px;
  `}

  ${props => props.height && css`
    height: ${props.height}px;
  `}

  ${props => props.reverseColor && css`
    border-top-color: #FFF;
  `}

  &:before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: #1071B0;
    animation: PreloaderSpin 2s linear infinite;

    ${props => props.reverseColor && css`
      border-top-color: #FFF;
    `}
  }

  &:after {
    content: "";
    position: absolute;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: #00BBF4;
    animation: PreloaderSpin 1s linear infinite;

    ${props => props.reverseColor && css`
      border-top-color: #FFF;
    `}
  }

  @keyframes PreloaderSpin {
    0%   {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/loaders/LoaderSmall/LoaderSmall.styles.js